import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersParams, GetVouchersResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";
import { List } from "entities/admin/model/slice/types";

export const getVouchers = createAsyncThunk<
  List<GetVouchersResponse>,
  GetVouchersParams
>(
  'vouchers/getVouchers',
  async (params, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchers(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting vouchers", error?.response?.data);
        return rejectWithValue(error?.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting vouchers", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })